import { render, staticRenderFns } from "./FieldDisplayLabel.vue?vue&type=template&id=6109b336&"
import script from "./FieldDisplayLabel.vue?vue&type=script&lang=js&"
export * from "./FieldDisplayLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports